// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { UpdateMember } from '../types/Model';

export interface UpdatableContext {
  update: (data?: UpdateMember) => void;
  clear: Function;
  isLoading: boolean;
}

export function loadContext<T>(key: string, defaultValue: T) {
  const value = localStorage.getItem(key);
  if (value) {
    return JSON.parse(value);
  }

  return defaultValue;
}

export function saveContext<T>(key: string, data: T) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function removeContext(key: string) {
  localStorage.removeItem(key);
}

export function cognitoClear() {
  const tempStored: any = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i) || '';
    if (!key.startsWith('Cognito')) {
      tempStored[key] = localStorage.getItem(key);
    }
  }
  localStorage.clear();
  Object.entries(tempStored).forEach(([key, value]) => {
    localStorage.setItem(key, String(value));
  });
}
